import styled from 'styled-components'

export const StyledTitleButton = styled.button`
    display: flex;
    gap: 16px;
    cursor: pointer;
    align-items: center;
    justify-content: space-between;
    border: none;
    border-top: 1px solid #D4D4D6;
    background: white;
    width: 100%;
    padding: 0px;
`

export const StyledTitle = styled.h5`
    font-family: "Roboto", Arial, Helvetica, sans-serif;
    font-size: 20px;
    font-weight: 500;
    line-height: 165%;
    letter-spacing: 0em;
    text-align: left;
    color: #3E3E47;
    margin: 16px 0px;
    ${props => props.theme.mediaQuery.down('mobile-portrait')} {
        font-size: 16px;
    }
`

export const StyledContent = styled.div`
    font-family: "Roboto", Arial, Helvetica, sans-serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 165%;
    letter-spacing: 0em;
    text-align: left;
    color: #282832;
    padding-bottom: 16px;
`
